// extracted by mini-css-extract-plugin
export default {"bounce":"w_cq","loading":"w_cr","logo-mark-bounce-right":"w_cs","logo-mark-bounce-left":"w_ct"};